var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"id":_vm.id,"title":_vm.title,"toggle":_vm.closeModal}},[_c('SuccessState',{attrs:{"message":_vm.message,"onSuccess":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }